import Fetch from '../utils/fetch'

export default {
  talentProcessList(params) {
    return Fetch({
      url: '/isp-talent/process/talentProcess/list',
      data: params
    })
  },
  getBatchByProjectId(params) {
    return Fetch({
      url: '/isp-talent/batch/batch/getBatchByProjectId',
      data: params,
      type: 'POST'
    })
  },
  getFinalStageProjectPage(params) {
    return Fetch({
      url: '/isp-talent/talentproject/talentProject/getFinalStageProjectPage',
      data: params,
      type: 'POST'
    })
  },
  queryById(params) {
    return Fetch({
      url: '/isp-talent/talentproject/talentProject/queryById',
      data: params
    })
  },
  progressList(params) {
    return Fetch({
      url: '/isp-talent/flow/final-progress',
      data: params
    })
  },
  finalProgress(params) {
    return Fetch({
      // url: '/isp-talent/flow/declaration/list-page',
      url: '/isp-talent/site/declare/list',
      data: params
    })
  },
  areacode(params) {
    return Fetch({
      url: '/isp-talent/sys/dict/getDictItems/areacode',
      data: params
    })
  },
  businessAuthorities(params) {
    return Fetch({
      url: '/isp-talent/sys/dict/getDictItems/business_authorities',
      data: params
    })
  },
  projectGuidance(params) {
    return Fetch({
      url: '/isp-talent/project/guidance',
      data: params
    })
  },
  customizeGet(params) {
    return Fetch({
      url: '/isp-talent/customize/get',
      data: params
    })
  },
  getUserInfo(params) {
    return Fetch({
      url: '/isp-talent/zjzw/getUserInfo',
      data: params
    })
  },
  employeeList(params) {
    return Fetch({
      url: '/isp-talent/company/employee/list',
      data: params
    })
  },
  employeeAdd(params) {
    return Fetch({
      url: '/isp-talent/company/employee/add',
      data: params,
      type: 'POST'
    })
  },
  employeeEdit(params) {
    return Fetch({
      url: '/isp-talent/company/employee/edit',
      data: params,
      type: 'POST'
    })
  },
  employeeDel(params) {
    return Fetch({
      url: '/isp-talent/company/employee/delete',
      data: params,
      type: 'GET'
    })
  },
  // 员工绑定发送验证码
  sendCaptcha(params) {
    return Fetch({
      url: '/isp-talent/company/employee/send-captcha',
      data: params,
      type: 'POST'
    })
  },
  // 解除绑定
  unbindCompany(params) {
    return Fetch({
      url: '/isp-talent/company/employee/unbound',
      data: params,
      type: 'POST'
    })
  },

  // 通过身份证号 获取 人才id
  getTalentId(params) {
    return Fetch({
      url: '/isp-talent/company/employee/get-talent-id',
      data: params,
      type: 'GET'
    })
  },

  // 批次时间
  batchList(params) {
    return Fetch({
      url: '/isp-talent/guidance/batch/list-all',
      data: params
    })
  },
  situationList(params) {
    return Fetch({
      url: '/isp-talent/guidance/situation/list-all',
      data: params
    })
  },
  // 申报方式
  reviewMethod(params) {
    return Fetch({
      url: '/isp-talent/sys/dict/getDictItems/review_method',
      data: params
    })
  },
  // 申报查询空表单
  declareForm(params) {
    return Fetch({
      url: '/isp-talent/site/declare/get-form',
      data: params,
      type: 'POST'
    })
  },

  // 是否显示
  getCondition(params) {
    return Fetch({
      url: '/isp-talent/site/declare/get-condition',
      data: params
    })
  },

  // 是否有数据
  judgeDeclare(params) {
    return Fetch({
      url: '/isp-talent/site/declare/judge',
      data: params,
      type: 'POST'
    })
  },

  // 保存
  declareSave(params) {
    return Fetch({
      url: '/isp-talent/site/declare/save',
      data: params,
      type: 'POST'
    })
  },
  // 提交
  declareSubmit(params) {
    return Fetch({
      url: '/isp-talent/site/declare/submit',
      data: params,
      type: 'POST'
    })
  },
  // 门户-申报详情
  declareDetail(params) {
    return Fetch({
      url: '/isp-talent/site/declare/detail',
      data: params
    })
  },

  // 门户-申报中心-附件编辑
  updateDeclareAttach(params) {
    return Fetch({
      url: '/isp-talent/site/declare/update-declare-attach',
      data: params,
      type: 'POST'
    })
  },

  // 门户-申报中心-附件提交
  resubmit(params) {
    return Fetch({
      url: '/isp-talent/site/declare/resubmit',
      data: params,
      type: 'POST'
    })
  },

  // 获取单个数据字典
  ajaxGetDictItems(code, params) {
    return Fetch({
      url: `/isp-talent/sys/dict/getDictItems/${code}`,
      data: params,
      type: 'GET'
    })
  },
  // 获取所有数据字典
  ajaxGetAllDictItems(params) {
    return Fetch({
      url: `/isp-talent/sys/dict/queryAllDictItems`,
      data: params,
      type: 'GET'
    })
  },
  // 表单打印成pdf
  getFormPdf(params) {
    return Fetch({
      url: `/isp-talent/pdf/generate`,
      data: params,
      type: 'POST',
      responseType: 'blob'
    })
  },

  // 单位审核列表
  getCompanyAuditList(params) {
    return Fetch({
      url: `/isp-talent/site/review/list-page`,
      data: params,
      type: 'GET'
    })
  },
  // 单位审核详情
  getCompanyAuditDetail(params) {
    return Fetch({
      url: `/isp-talent/site/review/detail`,
      data: params,
      type: 'GET'
    })
  },
  // 单位审核通过
  auditAgree(params) {
    return Fetch({
      url: `/isp-talent/site/review/agree`,
      data: params,
      type: 'POST'
    })
  },
  // 单位审核拒绝
  auditReject(params) {
    return Fetch({
      url: `/isp-talent/site/review/reject`,
      data: params,
      type: 'POST'
    })
  },
  //  获取单位拒绝的操作类型
  getRejectOperation(params) {
    return Fetch({
      url: `/isp-talent/site/review/reject-operation`,
      data: params,
      type: 'GET'
    })
  },
  // 获取申报批次下所有符合的地区
  getBatchArea(params) {
    return Fetch({
      url: `/isp-talent/site/declare/batch-area`,
      data: params,
      type: 'GET'
    })
  },
  // 修改申报人当前地区
  updateBatchArea(params) {
    return Fetch({
      url: `/isp-talent/site/declare/edit-area`,
      data: params,
      type: 'POST'
    })
  },
  // 删除申报草稿
  deleteDraft(params) {
    return Fetch({
      url: `/isp-talent/site/declare/delete-draft`,
      data: params,
      type: 'POST'
    })
  },
  // 大学生信息列表
  getCollegeInfoList(params) {
    return Fetch({
      url: `/isp-talent/college/talentCollegeInfo/getCollegeInfoList`,
      data: params,
      type: 'GET'
    })
  },
  // 大学生信息新增
  addCollegeInfo(params) {
    return Fetch({
      url: `/isp-talent/college/talentCollegeInfo/add`,
      data: params,
      type: 'POST'
    })
  },
  // 大学生信息编辑
  editCollegeInfo(params) {
    return Fetch({
      url: `/isp-talent/college/talentCollegeInfo/edit`,
      data: params,
      type: 'PUT'
    })
  },
  // 大学生信息删除
  delCollegeInfo(params) {
    return Fetch({
      url: `/isp-talent/college/talentCollegeInfo/gateway/delete`,
      data: params,
      type: 'GET'
    })
  },
  // 大学生信息详情查询
  getCollegeInfo(params) {
    return Fetch({
      url: `/isp-talent/college/talentCollegeInfo/queryById`,
      data: params,
      type: 'GET'
    })
  },
  // 社保数据查询
  getSocialInfo(params) {
    return Fetch({
      url: `/isp-talent/data/api/social-security`,
      data: params,
      type: 'POST'
    })
  },
  // 学信网数据查询
  getEducationInfo(params) {
    return Fetch({
      url: `/isp-talent/data/api/education-data`,
      data: params,
      type: 'POST'
    })
  },
  // 导入大学生信息
  importStudentInfo(params) {
    return Fetch({
      url: `/isp-talent/college/talentCollegeInfo/importExcel`,
      data: params,
      type: 'POST'
    })
  },

  // 检查申报项目是否可以撤回
  checkWithdraw(params) {
    return Fetch({
      url: `/isp-talent/site/declare/check-withdraw`,
      data: params,
      type: 'POST'
    })
  },
  // 撤回申报项目
  handleWithdraw(params) {
    return Fetch({
      url: `/isp-talent/site/declare/withdraw`,
      data: params,
      type: 'POST'
    })
  },

  // 二级申报类型列表
  getSecondaryTypeList(params) {
    return Fetch({
      url: `/isp-talent/guidance/situation/secondary-type/list`,
      data: params,
      type: 'GET'
    })
  },
  // 选中的 申报条件（地区，申报类型等）
  getSelectCondition(params) {
    return Fetch({
      url: `/isp-talent/site/declare/selected-condition`,
      data: params,
      type: 'GET'
    })
  },

  // 获取人才称号，人才层级及对应归口部门
  getTalentTitle(params) {
    return Fetch({
      url: `/isp-talent/title/relation/list-page`,
      data: params,
      type: 'GET'
    })
  }
}
